import React from 'react';
import { useNavigate } from 'react-router-dom';
import ManualSync from '../sync/ManualSync';
import EpicorSync from '../sync/EpicorSync';
import { PageHeader, Tabs, TabPanel } from '../ui';

const TABS = [
  { id: 'bigcommerce', label: 'Catalog (BigCommerce)', path: '/jobs/run' },
  { id: 'epicor', label: 'Customers & Parts (Epicor)', path: '/jobs/run/epicor' },
];

/**
 * Single entry point for manually triggering syncs.
 * Tabs are route-driven so /jobs/run and /jobs/run/epicor deep-link
 * directly to the right form (and legacy redirects keep working).
 */
const RunSync = ({ tab }) => {
  const navigate = useNavigate();

  const onChange = (id) => {
    const target = TABS.find((t) => t.id === id);
    if (target && target.id !== tab) navigate(target.path);
  };

  return (
    <div className="run-sync">
      <PageHeader
        title="Run Sync"
        sub="Trigger a one-off sync job. BigCommerce pushes catalog changes to the storefront; Epicor pulls the part master into staging."
      />
      <Tabs tabs={TABS} active={tab} onChange={onChange} label="Sync type" />
      <TabPanel id="bigcommerce" active={tab}>
        <ManualSync />
      </TabPanel>
      <TabPanel id="epicor" active={tab}>
        <EpicorSync />
      </TabPanel>
    </div>
  );
};

export default RunSync;
